<template>
  <FlexboxLayout class="wrapper" alignItems="stretch" style="height: 100%;">
    <AgCard class="head">
      <FlexboxLayout class="card-content" justifyContent="space-between" alignItems="center">
        <AgCaption :text="name" />
        <FlexboxLayout class="actions">
          <AgButton outlined icon="download" @tap="save" @click="save" aria-label="Datei herunterladen" />
          <AgButton icon="times" @tap="close" @click="close" aria-label="Schließen" />
        </FlexboxLayout>
      </FlexboxLayout>
    </AgCard>
    <StackLayout class="content">
      <AgImage v-if="isImage" :src="content" />
      <iframe v-else :src="content"></iframe>
    </StackLayout>
  </FlexboxLayout>
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: '[name]'
    },
    content: {
      type: String
    }
  },
  data: () => ({
    type: null
  }),
  computed: {
    isImage () {
      return typeof(this.type) == 'string' && this.type.substr(0, 6) === 'image/'
    }
  },
  watch: {
    content: {
      immediate: true,
      handler (to) {
        if (to && to.length) {
          this.type = to.split(';')[0].substr(5)
        }
      }
    }
  },
  methods: {
    save () {
      var link = document.createElement('a')
      link.download = this.name
      link.target = '_blank'
      link.href = this.content
      document.body.appendChild(link)
      link.click()
    },
    close () {
      this.$emit('done')
    }
  }
}

</script>

<style lang="scss" scoped>

html {
  .wrapper {
    flex-direction: column;
    overflow: hidden;
  }

  .button {
    margin-left: 20px;
  }

  .head {
    flex-shrink: 0;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) 0 env(safe-area-inset-left);
  }

  .head::v-deep .card-content {
    gap: 8px;
  }

  .head::v-deep .caption {
    font-size: 16px;
    margin-top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  .head::v-deep .actions {
    flex-shrink: 0;
  }

  .content {
    flex-grow: 1;
    min-height: 0;
    overflow: auto;
    background-color: #444;
    padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  }

  .content > * {
    width: 100%;
    height: 100%;
  }
}

</style>
